module.exports = __webpack_public_path__ + "static/images/filter-vertical.397911e60191127a28561555dbe6186d.svg";